import {
  GOOGLE,
  META,
  TIKTOK,
  FORMATS_MEDIA_META,
  FORMATS_MEDIA_TIKTOK,
  FORMATS_MEDIA_GOOGLE,
  MIN_DIMENSIONS_CONTENT,
  LINKEDIN,
  FORMATS_MEDIA_LINKEDIN,
  DOCUMENT_FORMATS_LINKEDIN,
} from "./constants";
import {
  optionsAdsCampaignObjectivesMeta,
  optionsAdsCampaignObjectivesTikTok,
  optionsCampaignsTypeGoogleAds,
  optionsAdsCampaignObjectivesLinkedin,
} from "./options";
import { getContentType } from "./dimensions";
import { getExtensionFile } from "./string";

export const ADS_CAMPAIGNS_OBJECTIVES_SUPPORTED_BY_PLATFORM = {
  [META]: optionsAdsCampaignObjectivesMeta,
  [TIKTOK]: optionsAdsCampaignObjectivesTikTok,
  [GOOGLE]: optionsCampaignsTypeGoogleAds,
  [LINKEDIN]: optionsAdsCampaignObjectivesLinkedin,
};

const dimensionsCache = new Map();

export const getDimensionsFromUrl = (url) => {
  if (dimensionsCache.has(url)) {
    return Promise.resolve(dimensionsCache.get(url));
  }

  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const dimensions = { width: img.naturalWidth, height: img.naturalHeight };
      dimensionsCache.set(url, dimensions);
      resolve(dimensions);
    };
    img.onerror = () => {
      reject(new Error("Failed to load the image"));
    };
    img.src = url;
  });
};

export const filterMediaByPlatform = async (mediaUrls, platform) => {
  if (!mediaUrls || mediaUrls.length === 0) return [];

  let acceptedFormats = [];
  switch (platform) {
    case META:
      acceptedFormats = FORMATS_MEDIA_META;
      break;
    case TIKTOK:
      acceptedFormats = FORMATS_MEDIA_TIKTOK;
      break;
    case GOOGLE:
      acceptedFormats = FORMATS_MEDIA_GOOGLE;
      break;
    case LINKEDIN:
      acceptedFormats = FORMATS_MEDIA_LINKEDIN.concat(
        DOCUMENT_FORMATS_LINKEDIN
      );
      break;
    default:
      acceptedFormats = FORMATS_MEDIA_META;
  }

  const validMediaUrls = [];

  for (const mediaUrl of mediaUrls) {
    if (!mediaUrl?.url) continue;

    const isCarousel =
      mediaUrl?.isCarousel &&
      Array.isArray(mediaUrl?.carouselImages) &&
      mediaUrl.carouselImages.length > 1;

    if (isCarousel) {
      const carouselUrls = mediaUrl.carouselImages
        .map((img) => (typeof img === "string" ? img : img?.url))
        .filter(Boolean);
      const allFormatsValid = carouselUrls.every((url) => {
        const ext = getExtensionFile(url);
        return acceptedFormats.includes(ext);
      });
      if (!allFormatsValid) continue;

      // Verify minimum dimensions for first image
      const contentType = getContentType(mediaUrl.url);
      if (contentType === "image") {
        const dimensions = await getDimensionsFromUrl(mediaUrl.url).catch(
          () => null
        );
        if (
          dimensions &&
          (dimensions.width < MIN_DIMENSIONS_CONTENT.width ||
            dimensions.height < MIN_DIMENSIONS_CONTENT.height)
        ) {
          continue;
        }
      }

      validMediaUrls.push(mediaUrl);
    } else {
      // Individual image/video
      const extension = getExtensionFile(mediaUrl.url);
      if (!acceptedFormats.includes(extension)) continue;

      const contentType = getContentType(mediaUrl.url);
      if (contentType === "image") {
        const dimensions = await getDimensionsFromUrl(mediaUrl.url).catch(
          () => null
        );
        if (
          dimensions &&
          (dimensions.width < MIN_DIMENSIONS_CONTENT.width ||
            dimensions.height < MIN_DIMENSIONS_CONTENT.height)
        ) {
          continue;
        }
      }

      validMediaUrls.push(mediaUrl);
    }
  }

  return validMediaUrls;
};
